import { trasladosTypes } from "./trasladosTypes";

const initialState = {
  solicitud: null,
  solicitudes: [],
  solicitudesTomadas: [],
  solicitudesTomadasUsuario: [],
  trackingSolicitud: [],

  tipoDocSolicitudes: [],

  tiposTraslados: [],
  accesorios: [],
  causasTraslados: [],
  motivosTraslados: [],
  sectoresTraslados: [],
  tipoSolicitudes: [],
  estados: [],
  codigos: [],
  tipoPrestaciones: [],
  tipoTracking: [],
  notasTraslado: []
};

export const trasladosReducer = (state = initialState, action) => {
  switch (action.type) {
    case trasladosTypes.getSolicitud:
      return {
        ...state,
        solicitud: action.payload
      }
    case trasladosTypes.cleanSolicitud:
      return {
        ...state,
        solicitud: null
      }

    case trasladosTypes.getSolicitudes:
      return {
        ...state,
        solicitudes: action.payload
      }
    case trasladosTypes.cleanSolicitudes:
      return {
        ...state,
        solicitudes: [],
        solicitudesTomadas: []
      }

    case trasladosTypes.getAllSolicitudesTomadas:
      return {
        ...state,
        solicitudesTomadas: action.payload
      }

    case trasladosTypes.getByUserSolicitudesTomadas:
      return {
        ...state,
        solicitudesTomadasUsuario: action.payload
      }

    case trasladosTypes.getTrackingSolicitud:
      return {
        ...state,
        trackingSolicitud: action.payload
      }

    case trasladosTypes.cleanTrackingSolicitud:
      return {
        ...state,
        trackingSolicitud: []
      }
    case trasladosTypes.getTipoDocSolicitudes:
      return {
        ...state,
        tipoDocSolicitudes: action.payload
      }
    case trasladosTypes.cleanTipoDocSolicitudes:
      return {
        ...state,
        tipoDocSolicitudes: []
      }
    case trasladosTypes.postTipoDocSolicitudes:
      return {
        ...state,
        tipoDocSolicitudes: [...state.tipoDocSolicitudes, action.payload]
      }
    case trasladosTypes.putTipoDocSolicitudes:
      return {
        ...state,
        tipoDocSolicitudes: state.tipoDocSolicitudes.map((item) => item.id === action.payload.id ? action.payload : item)
      }
    case trasladosTypes.deleteTipoDocSolicitudes:
      return {
        ...state,
        tipoDocSolicitudes: state.tipoDocSolicitudes.filter(({ id }) => id !== action.payload)
      }
    case trasladosTypes.getTiposTraslados:
      return {
        ...state,
        tiposTraslados: action.payload
      }
    case trasladosTypes.getAccesorios:
      return {
        ...state,
        accesorios: action.payload
      }
    case trasladosTypes.getCausasTraslados:
      return {
        ...state,
        causasTraslados: action.payload
      }
    case trasladosTypes.getMotivosTraslados:
      return {
        ...state,
        motivosTraslados: action.payload
      }
    case trasladosTypes.getSectoresTraslados:
      return {
        ...state,
        sectoresTraslados: action.payload
      }
    case trasladosTypes.getTipoSolicitudes:
      return {
        ...state,
        tipoSolicitudes: action.payload
      }
    case trasladosTypes.getEstados:
      return {
        ...state,
        estados: action.payload
      }
    case trasladosTypes.getCodigos:
      return {
        ...state,
        codigos: action.payload
      }
    case trasladosTypes.getTipoPrestaciones:
      return {
        ...state,
        tipoPrestaciones: action.payload
      }
    case trasladosTypes.postSolicitudTomada:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) => item.id === action.payload.idSolicitud ? { ...item, solicitudTrasladoTomada: action.payload } : item),
        solicitudesTomadas: [...state.solicitudesTomadas, action.payload],
      }
    case trasladosTypes.deleteSolicitudTomada:
      return {
        ...state,
        solicitudesTomadas: state.solicitudesTomadas.filter(({ id }) => id !== action.payload)
      }
    case trasladosTypes.deleteSolicitudEnCarga:
      return {
        ...state,
        solicitudes: state.solicitudes.filter(({ id }) => id !== action.payload)
      };
    case trasladosTypes.cambiarEstadoSolicitud:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) => item.id === action.payload.id ? action.payload : item)
      }
    case trasladosTypes.getTipoTracking:
      return {
        ...state,
        tipoTracking: action.payload
      }
    case trasladosTypes.getNotasTraslado:
      return {
        ...state,
        notasTraslado: action.payload
      }
    case trasladosTypes.postNotaTraslado:
      return {
        ...state,
        notasTraslado: [...state.notasTraslado, action.payload]
      }
    case trasladosTypes.putNotaTraslado:
      return {
        ...state,
        notasTraslado: state.notasTraslado.map(nota => nota.idNota === action.payload.idNota ? action.payload : nota)
      };
    case trasladosTypes.deleteNotaTraslado:
      return {
        ...state,
        notasTraslado: state.notasTraslado.filter(nota => nota.idNota !== action.payload)
      };
    default:
      return state;
  }
};
